import React from 'react';
import { Redirect } from 'react-router-dom';
import { X_API_KEY } from '../../utils/authentication';

export default class Logout extends React.Component {

	constructor(props) {
		super(props);

		localStorage.removeItem(X_API_KEY);
		localStorage.removeItem("user");
	}

	render() {

		return (<Redirect to='/login' />);
	}
}